import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class BasicView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    TweenMax.killTweensOf(container)
    TweenMax.set(container, {opacity: 0})
    TweenMax.to(container, .3, {opacity: 1})
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    TweenMax.killTweensOf(container)
    TweenMax.to(container, .25, {opacity: 0, delay: .25})
  }

}

export default BasicView